// Lightweight client-side tracker for "articles read" in the Recovery Library.
// We store a Set of slugs in localStorage so the count survives between visits
// without needing a server round-trip.

import { notifyActivityChange } from "@/lib/activity-events";


const KEY = "rt:articles-read";

function load(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr.filter((s) => typeof s === "string") : []);
  } catch {
    return new Set();
  }
}

export function markArticleRead(slug: string): void {
  if (!slug || typeof window === "undefined") return;
  const set = load();
  if (set.has(slug)) return;
  set.add(slug);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Array.from(set)));
  } catch {
    /* storage full / disabled — silent */
  }
  notifyActivityChange("article");
}


export function getArticlesReadCount(): number {
  return load().size;
}
